import type { AirBookingFlightItinerarySlice } from "@b2bportal/air-booking-api";
import type { TripSlice } from "@b2bportal/air-shopping-api";
import type { AirlineMap, AirportMap } from "@hopper-b2b/types";
import dayjs from "dayjs";
import { itineraryToTripSegment } from "./segments";

export const itineraryToTripSlice = (
  slice: AirBookingFlightItinerarySlice,
  isOutgoing: boolean,
  airlines: AirlineMap,
  airports: AirportMap
): TripSlice => {
  const firstSegment = slice.segments[0];
  const lastSegment = slice.segments[slice.segments.length - 1];
  const originCode = firstSegment.origin.locationCode;
  const destinationCode = lastSegment.destination.locationCode;

  const originName = airports?.[originCode]?.name ?? originCode;
  const destinationName = airports?.[destinationCode]?.name ?? destinationCode;

  const zonedDepartureTime =
    firstSegment.zonedUpdatedDeparture ??
    firstSegment.zonedScheduledDeparture ??
    "";
  const zonedArrivalTime =
    lastSegment.zonedUpdatedArrival ?? lastSegment.zonedScheduledArrival ?? "";
  const totalDurationMinutes = dayjs(zonedArrivalTime).diff(
    dayjs(zonedDepartureTime),
    "minutes"
  );

  return {
    departureTime:
      firstSegment.updatedDeparture ?? firstSegment.scheduledDeparture,
    zonedDepartureTime,

    arrivalTime: lastSegment.updatedArrival ?? lastSegment.scheduledArrival,
    outgoing: isOutgoing,
    destinationName,
    originCode,
    id: "",
    segmentDetails: slice.segments.map((segment) =>
      itineraryToTripSegment(segment, airlines, airports)
    ),
    originName,
    totalDurationMinutes,
    destinationCode,
    stops: slice.segments.reduce((acc, segment) => acc + segment.stops, 0),
  };
};
